import {observer} from 'mobx-react'
import {useStore} from 'rest/stores'
import {useEffect} from 'react'

export const Logout = observer(() => {
  const {AuthStore} = useStore()
  useEffect(() => {
    // window.location.href = '/' is essential to reset mobx stores
    AuthStore.signOut().then(() => (window.location.href = '/'))
  }, [AuthStore])

  return (
    <div className="flex flex-col justify-center items-center p-4">
      Sorry to see you go ...
    </div>
  )
})
